import { Tabs } from 'antd';
import styled from 'styled-components';

export const StyledTab = styled(Tabs)`
  .ant-tabs-nav {
    padding-left: 16px;
    background-color: #fff;
    margin: 0px;
  }
`;
